import { render } from "./ManagerProfileUpdate.vue?vue&type=template&id=6b626d67"
import script from "./ManagerProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ManagerProfileUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__